// extracted by css-extract-rspack-plugin
export default {"container":"TwoFactorAuthenticationSetup_container__SiLWc","close":"TwoFactorAuthenticationSetup_close__lhPnW"};